export default {
  filename: [ // virus script that gets injected into webpages
    /xpopup\.js/,
    /chrome:\/\/leapfrog.*/,

    // Chrome plugins errors
    /chrome\/RendererExtensionBindings/,
    /extensions\//,

    // LivingPlay toolbar
    /livingplay\.com/
  ],

  message: [
    /****************************************
     *      window.onerror exceptions       *
     ****************************************/
    /^Script error\.$/,
    /Error loading script/,
    /\[object Event\]/,

    // possibly from jQuery bug - http://dev.jquery.com/ticket/6529, filtered to reduce exception noise
    /['"]?document.body['"]? is null/,
    /'body' is null or not an object/,

    // Firefox bug - where you click "cancel" on the master password dialog throws the following exceptions
    /uncaught exception: unknown \(can't convert to string\)/,
    /Permission denied for .* to call method (UnnamedClass.toString|XULElement.QueryInterface) on <>/,
    /User canceled master password entry.*0x80004004/,

    // Firefox Flash plugin bug when page is in iframe - http://bugs.adobe.com/jira/browse/FP-561
    /Permission denied.* to (get property|call method) Location.toString/,
    /Permission denied to access property 'toString'/,

    // Firefox/Ext bug - http://www.sencha.com/forum/showthread.php?90890-CLOSED-3.0-Permission-denied-to-access-property-nodeType-from-non-chrome-context/page2
    /JavascriptError: window.onerror: Permission denied to access property 'nodeType' from a non-chrome context/,

    // Firefox plugins
    /chrome:\/\/.*\/content\/toolbar\.xul/,

    // NS_ERROR_XPC_BAD_CONVERT_JS from Norton securities and Siber Systems AI RoboForm
    /QueryInterface.*JS frame :: file:\/\/\//,

    // Userscripts
    // http://userscripts.org/scripts/review/93724
    //  matches: TypeError: content.responseText.match(/\[d:([0-9]+?\.[0-9]+?\.[0-9]+?)\]/i) is null'
    /TypeError: content.responseText.match\(\/\\\[d:\(\[0-9\]\+\?\\\.\[0-9\]\+\?\\\.\[0-9\]\+\?\)\\\]\/i\) is null/,

    // Chrome plugins
    // Possibly caused by PlaySushi; only logged on Chrome browsers, can not reproduce
    /Object function nodeName\(\) { \[native code\] } has no method 'toLowerCase'/,

    // edit this cookie plugin
    /Uncaught ReferenceError: exit is not defined/,

    // Safari plugins
    // occuring on Safari, with AdBlock installed. (http://safariadblock.com/) - http://code.google.com/p/adblockforchrome/issues/detail?id=4679
    /The first argument must be a beforeLoad event object/,

    // Conduit plugin
    // http://www.conduit.com/Developers/HtmlAndGadget/Methods/JSInjection.aspx
    /EBCallBackMessageReceived is not defined/,

    // Component returned failure code: 0x805e000a [nsIXMLHttpRequest.open] - caused by AdBlock plus!
    /'tagName' is null or not an object/,

    /^illegal character$/,

    // Injected scripts
    //  http://www.fixya.com/support/t5145224-get_message_bmi_load_undefined_when
    /'bmi_load' is undefined/,

    /*******************************************
     *      runtime exceptions                 *
     *******************************************/
    /Ext.ux.grid.GridViewMenuPlugin is not a constructor/
  ]
};
